export enum LineItemStatus {
    Reserved = 'Reserved',
    Out = 'Out',
    OffRent = 'Off Rent',
    Returned = 'Returned',
    Sold = 'Sold'
}
